
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "50px",
    "height": "50px",
    "viewBox": "0 0 50 50",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "开启"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "配置",
            "transform": "translate(-694.000000, -703.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "编组-11",
                "transform": "translate(640.000000, 547.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "编组-12"
                  },
                  "children": [
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "反馈:6/模态框:7/表格:7"
                      },
                      "children": [
                        {
                          "tag": "g",
                          "attrsMap": {
                            "id": "反馈:6/模态框/表格"
                          },
                          "children": [
                            {
                              "tag": "g",
                              "attrsMap": {
                                "id": "反馈/弹窗/模态框/表格"
                              },
                              "children": [
                                {
                                  "tag": "g",
                                  "attrsMap": {
                                    "id": "编组-5备份-6",
                                    "transform": "translate(24.000000, 126.000000)"
                                  },
                                  "children": [
                                    {
                                      "tag": "g",
                                      "attrsMap": {
                                        "id": "开启",
                                        "transform": "translate(30.000000, 30.000000)"
                                      },
                                      "children": [
                                        {
                                          "tag": "circle",
                                          "attrsMap": {
                                            "id": "椭圆形",
                                            "fill": "#DEECFF",
                                            "cx": "25",
                                            "cy": "25",
                                            "r": "25"
                                          }
                                        },
                                        {
                                          "tag": "g",
                                          "attrsMap": {
                                            "id": "对号",
                                            "transform": "translate(10.784314, 10.784314)",
                                            "fill": "#4895FF",
                                            "fill-rule": "nonzero"
                                          },
                                          "children": [
                                            {
                                              "tag": "path",
                                              "attrsMap": {
                                                "d": "M14.5734339,2.91469514 L14.5734346,2.91469514 C8.13450187,2.91382729 2.9139976,8.13291092 2.91314369,14.5718437 C2.912851,16.7434554 3.51908575,18.8720027 4.66352456,20.7175775 L4.6635245,20.7175775 C5.08809245,21.4017139 4.87766932,22.3004961 4.19353191,22.7250641 C3.50939552,23.149632 2.61061323,22.9392089 2.18604528,22.2550715 L2.18604543,22.2550717 C0.7532648,19.9493755 -0.00408933341,17.2880424 1.66067044e-05,14.5734253 C1.66067044e-05,6.52452878 6.52456213,0 14.5734586,0 C22.6223551,0 29.1468839,6.52452878 29.1468839,14.5734253 C29.1468839,22.6223218 22.6223551,29.1468631 14.5734586,29.1468631 L14.5734585,29.1468631 C11.7238142,29.1506062 8.9361091,28.315312 6.55806952,26.7451542 L6.55806944,26.7451542 C5.8716514,26.324866 5.6559125,25.4277027 6.07620407,24.7412847 C6.49649221,24.0548667 7.39365548,23.8391278 8.08007352,24.2594193 C8.10768282,24.2763244 8.13472109,24.2941448 8.16114349,24.3128506 L8.16114471,24.3128514 C13.5400665,27.8522099 20.7697892,26.3609432 24.3091477,20.9820145 C27.8485062,15.6030927 26.3572395,8.37337009 20.9783108,4.83401159 C19.0765384,3.58263581 16.8499928,2.91542052 14.5734662,2.91469299 L14.5734339,2.91469514 Z M22.1617991,11.9604131 L22.1617992,11.9604131 C22.7209504,11.3814819 22.7049139,10.4588824 22.1259817,9.89973122 C21.5612289,9.35427339 20.6658725,9.35427339 20.1011197,9.89973132 L13.1160938,16.8847572 L9.04573935,12.8144027 L9.04573932,12.8144027 C8.46680818,12.2552515 7.54420861,12.271288 6.98505746,12.8502202 C6.43959963,13.414973 6.43959963,14.3103294 6.98505753,14.8750822 L12.085741,19.9757656 L12.0857409,19.9757655 C12.6548316,20.5446854 13.5773287,20.5446854 14.1464228,19.9757657 L22.1618118,11.9603767 L22.1617991,11.9604131 Z",
                                                "id": "形状"
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  